/**
 * @generated SignedSource<<72a800b1c75c8eb5d171aa6c7dfc1aa8>>
 * @relayHash e73759bc41c74035fd9f794c71281255
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID df8175abc930f5870aee692a621f62c86ee043f5d288d4dce04e21da6f7e7a6f

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { WorkItemEntrypointUiQuery } from './WorkItemEntrypointUiQuery.graphql';

import isJscInlineEditFastFollowsEnabled_provider from '@atlassian/jira-relay-provider/src/is-jsc-inline-edit-fast-follows-enabled.relayprovider';
import shouldShowHumanSupervisor_provider from '@atlassian/jira-relay-provider/src/jira-ai-show-human-supervisor-avatar.relayprovider';
import isNumberFieldConfigurableEnabled_provider from '@atlassian/jira-relay-provider/src/jira-number-field-configuration-enabled.relayprovider';
import fixDisabledVotingOption_provider from '@atlassian/jira-relay-provider/src/jracloud-81233-fix-disabled-voting-option.relayprovider';
import isIssueViewFieldConfigEditEnabled_provider from '@atlassian/jira-relay-provider/src/relay-migration-issue-fields-custom-field-config.relayprovider';
import isRemoveIssueTypes_provider from '@atlassian/jira-relay-provider/src/remove-issue-types-dfo.relayprovider';
import simplifiedTimeTracking_provider from '@atlassian/jira-relay-provider/src/simplified-time-tracking.relayprovider';

const node: PreloadableConcreteRequest<WorkItemEntrypointUiQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "df8175abc930f5870aee692a621f62c86ee043f5d288d4dce04e21da6f7e7a6f",
    "metadata": {},
    "name": "WorkItemEntrypointUiQuery",
    "operationKind": "query",
    "text": null,
    "providedVariables": {
      "__relay_internal__pv__atlassianjirarelayprovidersrcjracloud81233fixdisabledvotingoptionrelayprovider": fixDisabledVotingOption_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcremoveissuetypesdforelayprovider": isRemoveIssueTypes_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcrelaymigrationissuefieldscustomfieldconfigrelayprovider": isIssueViewFieldConfigEditEnabled_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcjiranumberfieldconfigurationenabledrelayprovider": isNumberFieldConfigurableEnabled_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcisjscinlineeditfastfollowsenabledrelayprovider": isJscInlineEditFastFollowsEnabled_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcsimplifiedtimetrackingrelayprovider": simplifiedTimeTracking_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcjiraaishowhumansupervisoravatarrelayprovider": shouldShowHumanSupervisor_provider
    }
  }
};

export default node;
